<template>
<div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">포인트 이력</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>거래유형</p>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" value="" checked v-model="searchInfo.tx_type" @change="fn_page_init">
                  <label for="radio1">전체</label>
                </div>
                <div v-for="(item, index) in txTypeList" :key="index" class="form_radio">
                  <input type="radio" :id="index" name="radio" :value="item.dtl_code" v-model="searchInfo.tx_type" @change="fn_page_init">
                  <label :for="index">{{item.dtl_code_nm}}</label>
                </div>
              </li>
              <li>
                  <p>조회기간</p>
                  <Datepicker v-model="searchInfo.startDt" :defaultDate="searchInfo.startDt" :format="'YYYY-MM-DD'" @change="fn_page_init"/>
                  ~
                  <Datepicker v-model="searchInfo.endDt" :defaultDate="searchInfo.endDt" :format="'YYYY-MM-DD'" @change="fn_page_init"/>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
          <table class="list">
            <colgroup>
              <col width="25%">
              <col width="25%">
              <col width="25%">
              <col width="25%">
            </colgroup>
            <thead>
            <tr>
              <th>한의원명</th>
              <th>회원ID</th>
              <th>회원명</th>
              <th>포인트점수</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><span>{{ clinicDoctorInfo.clinic_nm }}</span></td>
              <td><span>{{ clinicDoctorInfo.clinic_doctor_id }}</span></td>
              <td><span>{{ clinicDoctorInfo.doctor_nm }}</span></td>
              <td><span>{{ fn_comma_won(clinicDoctorInfo.point_balance) }} 점</span></td>
            </tr>
            </tbody>
          </table>
          </div>
          <div class="table_list">
            <table class="list">
              <colgroup>
                <col width="25%">
                <col width="25%">
                <col width="25%">
                <col width="25%">
              </colgroup>
              <thead>                  
                <tr>
                    <th>처리일자</th>
                    <th>거래유형</th>
                    <th>포인트</th>
                    <th>사유</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="userPointDetailList.length == 0">
                    <td colspan="10"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in userPointDetailList" :key="index">
                  <td><span>{{ item.reg_dt }}</span></td>
                  <td><span>{{ item.tx_type_nm }}</span></td>
                  <td>
                    <span v-if="item.tx_type == 'S' || item.tx_type == 'C'" class="font_blue">{{ fn_comma_won(item.point) }} 점</span>
                    <span v-else class="font_red">{{ fn_comma_won(item.point) }} 점</span>
                  </td>
                  <td><span>{{ item.reason }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo=searchInfo.pageInfo @clickPage="moveGrpPage" v-show="pagingShow"/>
          </div>
          <div class="bottom_box bn">
            <button class="btn btn_md btn_darkbrown" @click="fn_move_listPage">
              목록
            </button>
          </div>
        </section>
      </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import Datepicker from '@/components/Datepicker.vue'
    import commonUtil from "@/mixin/commonUtil"

export default {
    name: 'herbUsageReport',
    mixins: [commonUtil],
    components: {
      Pagination,
      Datepicker,
    },
    data() {
      return {
        clinicDoctorInfo : {},
        searchInfo : {
            clinic_doctor_id : '',
            tx_type : '',
            startDt : '',
            endDt: '',
            pageInfo : {  
              page : '1',
              pageSize : '10',
              totPage : '0'
            } 
        },
        changeInfo : false,
        pagingShow : false,
        userPointDetailList: [],
        txTypeList : []
      }
    },
    async created(){
      //오늘 날짜구하기
      this.searchInfo.startDt = this.getAddMonthDate(-1);
      this.searchInfo.endDt = this.getCurrentDate();

      this.clinicDoctorInfo = this.$store.getters['userMngt/getClinicDoctorInfo'];
      this.searchInfo.clinic_doctor_id = this.clinicDoctorInfo.clinic_doctor_id;

      this.txTypeList = await this.getCode('GC00000019');

    },
    mounted(){
        //오늘 날짜구하기
        this.searchInfo.startDt =  this.getAddMonthDate(-1);
        this.searchInfo.endDt = this.getCurrentDate();
        this.fn_search();
    },
    methods : {
        fn_search(){

            //console.log("@@@@ regData : %o",this.regData);
            if(this.changeInfo){
                this.searchInfo.pageInfo.page = '1';
            }
            axios
                .post("/api/admin/userMngt/getUserPointDetailList", this.searchInfo)
                .then((res) => {

                    this.userPointDetailList = res.data.userPointDetailList;

                    console.log("@@@@ userPointDetailList : %o",this.userPointDetailList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;

                    if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;
                    }

                    this.changeInfo = false;
                })
                .catch((err) => console.log(err));
            
        },
        moveGrpPage(page){
            this.searchInfo.pageInfo.page = page;
            this.fn_search();
        },
        fn_page_init(){
            this.changeInfo = true;
        },
        fn_move_listPage(){
          this.$store.dispatch('userMngt/setClinicDoctorInfo', null);
          this.$router.push("/admin/userMngt/userPointList");
        }
    }
  }
</script>